module.exports = __webpack_public_path__ + "static/media/concert-2.8ec5fe91.png";